import { fromJS } from 'immutable'
import {
  POSITION_DEACTIVATE_REQUEST,
  POSITION_DEACTIVATE_SUCCESS,
  POSITION_DEACTIVATE_FAILURE,
  POSITION_DEACTIVATE_RESET,
} from './../../constants'

const init = fromJS({
  isFetching: false,
  // isAuthenticated: localStorage.getItem('access_token') !== null,
})

export default (state = init, action) => {
  switch (action.type) {
    case POSITION_DEACTIVATE_REQUEST:
      return state
        .set('isFetching', true)
    case POSITION_DEACTIVATE_SUCCESS:
      return state
        .set('positionDeactivate', fromJS(action.payload.deletedPosition))
        .set('status', 200)
        .set('message', 'Deleted Successfully.')
        .set('isFetching', false)
    case POSITION_DEACTIVATE_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('positionDeactivate', fromJS(action.payload.message))
        .set('status', fromJS(action.payload.response.statusCode))
        .set('message', fromJS(action.payload.response.message))
        .set('isFetching', false)
    case POSITION_DEACTIVATE_RESET:
      return state
        .delete('positionDeactivate')
        .delete('status')
        .delete('message')
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/position/position-deactivate-reducer.js